// DataMetricks contact details used on the contact page (same as the old /contact-us page and the site footer).
// NOTE: working hours are taken from the design mockup; confirm them with DataMetricks.
export const contactInfo = {
  phone: "+91 73039 46657",
  phoneHref: "tel:+917303946657",
  email: "contact@datametricks.com",
  addressLine1: "A40, Ithum Tower, Sector 62",
  addressLine2: "Noida, Uttar Pradesh 201309",
  hours: "Mon - Sat: 9:00 AM - 6:00 PM",
  closed: "Sunday: Closed",
  mapQuery: "DataMetricks Consulting, A40 Ithum Tower, Sector 62, Noida, Uttar Pradesh 201309",
};
